import React from 'react';
import Page from '../../../layout/Page';
import Activity from './Activity';
import RedeemedAppWash from './RedeemedAppWash';
import AirPayTransactions from './AirPayTransactions';
import PromoCode from './PromoCode';
import ClaimedDeals from './ClaimedDeals';
import AppReferral from './AppReferral';
import AppRevenue from './AppRevenue';
import { userRoles } from '../../../RoleProtected';

const MobileAppReport = ({ children, ...props }) => {

    return (
        <Page
            title='Mobile App'
            tabs
        >
            {/* <Activity tab='Activity' roles={userRoles.viewUsageReports}/> */}
            <AppRevenue tab='App Revenue' roles={userRoles.viewFinancialReports}/>
            <RedeemedAppWash tab='Redeemed Washes' roles={userRoles.viewUsageReports}/>
            {/* <WashClubReport tab='Wash Club Report'  roles={userRoles.viewUsageReports} /> */}
            <AirPayTransactions tab='AirPAY Transactions'  roles={userRoles.viewAuditReports} />
            {/* <AirPayByLocation tab='Air Pay By Location' /> */}
            <PromoCode tab='Promo Code'  roles={userRoles.viewAuditReports} />
            <ClaimedDeals tab='Claimed Deals'  roles={userRoles.viewAuditReports} />
            <AppReferral tab='App Referral' roles={userRoles.viewAuditReports} />
        </Page >
    );
}

export default MobileAppReport;
